import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { FindMoneyService } from '@brightside-web/desktop/feature/find-money';
import { ExternalPartnerType, PartnerDetails } from '@brightside-web/desktop/data-access/shared';

@Component({
    selector: 'brightside-web-find-money-partner-intro-view',
    templateUrl: './find-money-partner-intro-view.component.html',
    styleUrls: ['./find-money-partner-intro-view.component.scss'],
    standalone: false
})
export class FindMoneyPartnerIntroViewComponent implements OnInit {
  partnerIntro$: Observable<PartnerDetails | undefined> = this._findMoneyService.currentPartnerDetails$;
  private _currentPartnerKey: string;

  constructor(private _findMoneyService: FindMoneyService, private _router: Router, private _route: ActivatedRoute) {}

  ngOnInit(): void {
    this._currentPartnerKey = this._route.snapshot.params['partnerKey'];
    this._findMoneyService.getPartnerDetails(ExternalPartnerType.FindMoney, this._currentPartnerKey || '');
  }

  goBackToPartnerList(): void {
    this._router.navigate(['../../view'], { relativeTo: this._route });
  }

  goToPartnerRedirectUrl(partner: PartnerDetails): void {
    this._findMoneyService.postToExternalPartner(partner.key);
    window.open(partner.url, '_blank');
  }
}
